<div *ngVar="isOpened$ | async as isOpened" class="tw-border-solid tw-border-0 tw-border-b tw-border-b-light-grey-600">
  <div
    class="tw-flex tw-justify-center tw-p-4 tw-cursor-pointer"
    [class.tw-opacity-50]="!isMapExpendable || !firstChunkLoaded"
    [matTooltip]="tooltipMessage | translate : { amount: mapThreshold }"
    (click)="toggleMap()"
  >
    <ui-svg-icon [name]="iconNames.Map" [width]="24" class="tw-mr-2.5"></ui-svg-icon>
    <span>{{
      (isMapExpendable && !(completelyLoaded$ | async)
        ? 'monitoring.shipmentsTrackingMap.loadingTitle'
        : 'monitoring.shipmentsTrackingMap.title'
      ) | translate
    }}</span>
    <ui-svg-icon *ngIf="isOpened" [name]="iconNames.Up" [width]="24" class="tw-ml-2.5"></ui-svg-icon>
    <ui-svg-icon *ngIf="!isOpened" [name]="iconNames.Down" [width]="24" class="tw-ml-2.5"></ui-svg-icon>
  </div>

  @if(authFacade.mapsPluginAccepted$ | async){

  <div
    class="map-container"
    [class.map-container_closed]="!isOpened"
    [class.map-container_opened]="isOpened"
    [class.tw-opacity-50]="!(completelyLoaded$ | async)"
    [class.tw-pointer-events-none]="!firstChunkLoaded"
  >
    <div>
      <ng-container #mapContainer></ng-container>
    </div>
  </div>
  } @else{ @if (isOpened){
  <div class="tw-flex tw-justify-center tw-items-center tw-p-4">
    {{ 'monitoring.shipmentsTrackingMap.mapsPluginNotAccepted' | translate }}
  </div>
  } }
</div>
